import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { APP_ICONS } from "../../assets";
import DashboardCard from "../../components/cards/DashboardCard";
import CustomBar from "../../components/customBar";
import NavigationDrawer from "../../components/navigationDrawer";
import PlatformChart from "./PlatformChart";
import {
  Person,
  Home,
  AccessTime,
  AttachMoney,
  Event,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Divider,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import TableData from "../../Data/users.json";
import DynamicTable from "../../components/dynamicTable";
import AppContainer from "../../components/containers/AppContainer";
import SelectInput from "@mui/material/Select/SelectInput";
import { useNavigate } from "react-router-dom";
import { fetchDashboard, getDashboard } from "../../services/dashBoardFn";
import AppLoader from "../../components/loader/loader";

const selectInputWith = {
  width: { xs: "100%", md: "150px" },
};

const tableHeader = ["USER NAME", "EMAIL", "STATUS"];

const displayRows = ["firstname", "email", "vendor_status"];

const DashboardPage = () => {
  const navigate = useNavigate();

  const [dashboardData, setDashboardData] = useState({});
  const [isLoading, setisLoading] = useState(false);

  let cartData = [
    {
      icon: <Person sx={{ fontSize: 40 }} color={"primary.light"} />,
      value: dashboardData?.customers || 0,
      title: "Customers",
    },
    {
      icon: <Event sx={{ fontSize: 40 }} color={"primary.light"} />,
      value: dashboardData?.providers || 0,
      title: "Providers",
    },
    {
      icon: <AccessTime sx={{ fontSize: 40 }} color={"primary.light"} />,
      value: dashboardData?.totalJobs || 0,
      title: "Total Jobs",
    },
  ];
  const getDashboardData = async () => {
    setisLoading(true);
    try {
      const response = await fetchDashboard();
      if (response.data.status === "success") {
        console.log(response.data.data, "responsessssssssssssssss");
        setDashboardData(response.data.data);
        setisLoading(false);
      }
    } catch (error) {
      console.log(error, "error");
      setisLoading(false);
    }
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <NavigationDrawer>
      {/* Mini Header */}
      <CustomBar title={"DASHBOARD"} />
      <AppLoader isVisible={isLoading} />
      {/* Dashboard Cards */}
      <Grid container spacing={2} mb={3}>
        {cartData.map((item, index) => {
          return (
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <DashboardCard key={index} cardData={item} cardIndex={index} />
            </Grid>
          );
        })}
      </Grid>

      {/* Dashboard Chart */}

      <PlatformChart earnings={dashboardData?.earnings || []} />

      <Box display={"flex"} justifyContent={"space-between"}>
        <Box width={"48%"} my={5}>
          <AppContainer>
            <Stack
              px={3}
              py={2}
              gap={2}
              direction={{ md: "row" }}
              alignItems={"center"}
              maxHeight={"500px"}
            >
              {/* <TextInput
            sx={{ flex: 1 }}
            placeholder={"Search Vendors"}
            InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          /> */}
              <Stack>
                <Typography variant="h5" fontWeight={600}>
                  All Customers
                </Typography>
                <Typography
                  fontSize={"1.125rem"}
                  color={"customColor.dustyGray"}
                >
                  latest
                </Typography>
              </Stack>

              <Stack
                direction={{ sm: "row" }}
                width={"100%"}
                flex={2}
                gap={2}
                justifyContent={{ md: "flex-end" }}
              >
                <Button
                  sx={{ backgroundColor: "piramry.light", width: "100px" }}
                  onClick={() => navigate("/customer")}
                >
                  View All
                </Button>
              </Stack>
            </Stack>
            <Divider />
            <DynamicTable
              tableHeader={tableHeader}
              displayRows={displayRows}
              tableData={dashboardData?.allCustomers || []}
              // showPagination={true}
              // showUserMenu={true}
              sx={{ width: "100%" }}
            />
          </AppContainer>
        </Box>
        <Box width={"48%"} my={5}>
          <AppContainer>
            <Stack
              px={3}
              py={2}
              gap={2}
              direction={{ md: "row" }}
              alignItems={"center"}
            >
              {/* <TextInput
            sx={{ flex: 1 }}
            placeholder={"Search Vendors"}
            InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          /> */}

              <Stack>
                <Typography variant="h5" fontWeight={600}>
                  All Providers
                </Typography>
                <Typography
                  fontSize={"1.125rem"}
                  color={"customColor.dustyGray"}
                >
                  latest
                </Typography>
              </Stack>
              <Stack
                direction={{ sm: "row" }}
                width={"100%"}
                flex={2}
                gap={2}
                justifyContent={{ md: "flex-end" }}
              >
                <Button
                  sx={{ backgroundColor: "piramry.light", width: "100px" }}
                  onClick={() => navigate("/providers")}
                >
                  View All
                </Button>
              </Stack>
            </Stack>
            <Divider />
            <DynamicTable
              tableHeader={tableHeader}
              displayRows={displayRows}
              tableData={dashboardData?.allWorkers || []}
              // showPagination={true}
              // showUserMenu={true}
            />
          </AppContainer>
        </Box>
      </Box>
    </NavigationDrawer>
  );
};

export default DashboardPage;
